import React from "react";
import PropTypes from "prop-types";
import { FormikCheckbox, ExpandableNumberedList } from "@qgiv/core-donor";
import { Chip, ChipContent, colors } from "@qgiv/core-react";

const CommitmentAgreement = ({
    agreementHeader,
    additionalText = "",
    commitmentAgreementPaymentDisclaimer,
    additionalHasCommitment,
    primaryHasCommitment,
    primaryText = "",
    additionalRegistrantCommitmentDetails = [],
}) => (
    <div className="col col--12 commitment-agreement-container">
        <div className="-padding-bottom--15">
            <h4 className="-padding-bottom--15">{agreementHeader}</h4>
            <FormikCheckbox
                id="commitment-agreement"
                innerPadding={false}
                name="Commitment_Agreement"
            >
                {primaryHasCommitment && primaryText}
                {/* Add spacing between primary and additional commitments if they are both visible */}
                {primaryHasCommitment && additionalHasCommitment && (
                    <>
                        <br />
                        <br />
                    </>
                )}
                {additionalHasCommitment && (
                    <>
                        <strong>{additionalText}</strong>
                        <br />
                        <br />
                        <ExpandableNumberedList
                            showMoreLink="Show More"
                            showLessLink="Show Less"
                            expandableList={
                                additionalRegistrantCommitmentDetails
                            }
                            threshold={4}
                        />
                    </>
                )}
            </FormikCheckbox>
        </div>
        <Chip bgColor={colors.SYSTEM_LIGHT}>
            <ChipContent
                glyph="info-circle-solid"
                label={commitmentAgreementPaymentDisclaimer}
            />
        </Chip>
    </div>
);

CommitmentAgreement.propTypes = {
    additionalHasCommitment: PropTypes.bool.isRequired,
    additionalRegistrantCommitmentDetails: PropTypes.arrayOf(PropTypes.string),
    additionalText: PropTypes.string,
    agreementHeader: PropTypes.string.isRequired,
    commitmentAgreementPaymentDisclaimer: PropTypes.string.isRequired,
    primaryHasCommitment: PropTypes.bool.isRequired,
    primaryText: PropTypes.string,
};

export default CommitmentAgreement;
